import * as rmd from 'material-ui';
import React from 'react';
import TeamPicker from './TeamPicker';
import config from 'cfg';
import Promise from 'bluebird';
import moment from 'moment';
import ArrowDropRight from 'material-ui/svg-icons/navigation-arrow-drop-right';
import EventByDatePicker from './EventByDatePicker';

class EventByTeamPicker extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            teamId: +props.teamId,
            eventId: +props.eventId,
            events: [],
            finished: [],
            upcoming: [],
            eventPicker: false,
        };
    }

    static defaultProps = {
        limit: 10,
    };

    componentDidMount() {
        this.handleTeamChange(null, this.state.teamId);
    }

    handleTeamChange = (key, value) => {
        var teamId = value;
        var { limit } = this.props;
        var date = moment().format('YYYY-MM-DD');
        this.setState({ teamId });
        this.props.onChange('teamId', teamId);
        return Promise.props({
            finished: fetch(
                `${config.apis.ss2}/events-v2?teamId=${teamId}&limit=${limit}&toDate=${date}&sortDirection=desc`,
            ),
            upcoming: fetch(`${config.apis.ss2}/events-v2?teamId=${teamId}&limit=${limit}&fromDate=${date}`),
        })
            .then(result => {
                return Promise.props({
                    finished: result.finished.status === 200 && result.finished.json(),
                    upcoming: result.upcoming.status === 200 && result.upcoming.json(),
                });
            })
            .then(res => {
                this.setState({
                    events: [].concat(res.finished.events.reverse()).concat(res.upcoming.events),
                    finished: res.finished.events,
                    upcoming: res.upcoming.events,
                });
            });
    };

    renderOption(e) {
        // var text = `${moment(e.startDate).utc().format('DD.MM')} ${e.homeShortName}-${e.awayShortName}`;
        var text = `${moment(e.startDate)
            .utc()
            .format('DD MMM')} ${e.homeName} - ${e.awayName}`;
        var secondaryText = null;
        if (e.statusType === 'finished') {
            secondaryText = `${e.score.home}-${e.score.away}`;
        }
        return (
            <rmd.MenuItem
                style={{ minWidth: '500px' }}
                key={e.eventId}
                value={e.eventId}
                primaryText={text}
                secondaryText={secondaryText}
            />
        );
    }

    handleEventChange = (e, key, val) => {
        if (val == -1) {
            this.setState({ eventPicker: true });
        } else {
            this.setState({ eventId: val }, () => {
                this.props.onChange('eventId', val);
            });
        }
    };

    render() {
        var eventsOptions = this.state.events;
        const { finished, upcoming, eventPicker, eventId } = this.state;

        var customSelection = eventId && !_.find(eventsOptions, e => e.eventId == eventId);

        return (
            <div>
                <TeamPicker onChange={this.handleTeamChange} teamId={this.state.teamId} />
                <rmd.SelectField
                    floatingLabelText="Events"
                    //value={this.state.eventId}
                    disabled={!this.state.teamId}
                    autoWidth
                    style={{ overflow: 'hidden', width: '100%' }}
                    value={this.state.eventId}
                    onChange={this.handleEventChange}
                >
                    {finished.map(this.renderOption)}
                    <rmd.Divider key="1" />
                    {upcoming.map(this.renderOption)}
                    <rmd.Divider key="2" />
                    <rmd.MenuItem key="3" value={-1} primaryText="Search event" rightIcon={<ArrowDropRight />} />
                    {customSelection && <rmd.Divider key="4" />}
                    {customSelection && (
                        <rmd.MenuItem key="custom" value={eventId} primaryText="Custom event" secondaryText={eventId} />
                    )}
                </rmd.SelectField>
                <rmd.Dialog
                    open={eventPicker}
                    onRequestClose={() => this.setState({ eventPicker: false })}
                    modal={false}
                >
                    <div className="preview">
                        <EventByDatePicker
                            style={{ minWidth: '500px' }}
                            onChange={(key, val) => {
                                if (key == 'eventId') {
                                    this.setState({ eventPicker: false, eventId: val }, () => {
                                        this.props.onChange && this.props.onChange('eventId', val);
                                    });
                                }
                            }}
                        />
                    </div>
                </rmd.Dialog>
            </div>
        );
    }
}

export default EventByTeamPicker;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/pickers/EventByTeamPicker.js
 **/